import { render, staticRenderFns } from "./sound.vue?vue&type=template&id=343c351c"
import script from "./sound.vue?vue&type=script&lang=js"
export * from "./sound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports